import laughUrl from '../audio/laugh.wav';

let player;
export function playLaughSound() {
  try {
    if (!player) {
      player = new window.Audio(laughUrl);
      player.preload = 'auto';
      player.volume = .8;
    }
    player.currentTime = 0;
    // Call play directly in the tap handler to retain browser user activation.
    const playing = player.play();
    if (playing?.catch) playing.catch(error => console.warn('Laugh audio could not play:', error.name));
  } catch (error) { console.warn('Laugh audio unavailable:', error.name); }
}
